import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App'
import { AuthProvider } from './auth/AuthContext'
import { colors } from './theme'
import './index.css'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_AUTH_GOOGLE_CLIENT_ID as
  | string
  | undefined

function MissingClientIdScreen() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: colors.purple,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 520,
          background: colors.white,
          borderRadius: 18,
          padding: '40px 36px',
          color: colors.black,
          boxShadow: '0 20px 60px rgba(35,31,32,0.18)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            marginBottom: 18,
          }}
        >
          <img
            src="/parkify-logo.svg"
            alt="Parkify"
            style={{ height: 24, width: 'auto', display: 'block' }}
          />
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '2.5px',
              color: colors.purple,
              textTransform: 'uppercase',
              borderLeft: `1px solid ${colors.divider}`,
              paddingLeft: 12,
              lineHeight: 1,
            }}
          >
            Sales · Config Missing
          </span>
        </div>
        <h1
          style={{
            fontSize: 24,
            fontWeight: 700,
            letterSpacing: '-0.5px',
            margin: '0 0 12px',
            color: colors.black,
          }}
        >
          Google sign-in isn't configured
        </h1>
        <p
          style={{
            fontSize: 14,
            color: colors.textMuted,
            lineHeight: 1.65,
            margin: '0 0 20px',
          }}
        >
          The portal needs a Google OAuth Web Client ID. Set{' '}
          <code
            style={{
              background: colors.bg,
              padding: '2px 6px',
              borderRadius: 4,
              color: colors.purple,
              fontSize: 12,
            }}
          >
            VITE_AUTH_GOOGLE_CLIENT_ID
          </code>{' '}
          and restart the dev server.
        </p>
        <div
          style={{
            background: colors.bg,
            border: `1px solid ${colors.divider}`,
            borderRadius: 8,
            padding: '14px 16px',
            fontFamily: 'ui-monospace, SFMono-Regular, monospace',
            fontSize: 12,
            color: colors.black,
          }}
        >
          <div style={{ color: colors.textDim, marginBottom: 6 }}>
            # parkify-sales/portal/.env.local
          </div>
          VITE_AUTH_GOOGLE_CLIENT_ID=
          <span style={{ color: colors.purple, fontWeight: 700 }}>
            your-client-id.apps.googleusercontent.com
          </span>
        </div>
        <p
          style={{
            fontSize: 12,
            color: colors.textMuted,
            lineHeight: 1.65,
            margin: '20px 0 0',
          }}
        >
          Authorized JavaScript origins must include{' '}
          <code>http://localhost:5178</code> (dev) and{' '}
          <code>https://parkify-sales-portal.pages.dev</code> (prod). The
          existing parkify-pay-ops client ID is reusable — add this portal's
          origins to it. See <code>.env.example</code> for the full setup.
        </p>
      </div>
    </div>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {GOOGLE_CLIENT_ID ? (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </GoogleOAuthProvider>
    ) : (
      <MissingClientIdScreen />
    )}
  </React.StrictMode>,
)
